import React from 'react';
import { Icon } from 'antd';

interface IProps {
  header: string;
  text: string;
}

interface IState {
  isOpen: boolean;
}

class InfoFaqItem extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isOpen: false,
    }
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const { isOpen } = this.state;
    const { header, text } = this.props;

    return (
      <div className='info-faq-item'>
        <div className='question' onClick={ this.toggleOpen }>
          <span className='text'>{ header }</span>
          <Icon type={ isOpen ? 'caret-up' : 'caret-down' } />
        </div>
        { isOpen &&
          <div className='answer' dangerouslySetInnerHTML={ { __html: text } } />
        }
      </div>
    );
  }
}

export default InfoFaqItem;


// WEBPACK FOOTER //
// ./src/components/InfoFaq/InfoFaqItem.tsx